import { Link } from "react-router-dom";
import { Moon } from "lucide-react";
import { Reveal } from "../components/motion";

export default function FindBuddy() {
  return (
    <div className="bg-cream" data-testid="find-buddy-page">
      <div className="mx-auto max-w-xl px-6 py-28 text-center">
        <Reveal>
          <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-blush">
            <Moon className="text-pinkdeep" size={34} />
          </span>
          <h1 className="mt-8 font-display text-4xl font-medium text-navy sm:text-5xl">The Buddy Match Quiz</h1>
          <p className="mt-5 text-base leading-relaxed text-navy/60">
            A few fun questions about your little dreamer are coming soon — and we'll introduce you to their perfect Buddy.
          </p>
          <Link to="/buddy/luna-the-unicorn" data-testid="quiz-back-cta"
            className="mt-10 inline-block rounded-full bg-pink px-8 py-4 font-body text-base font-bold text-navy transition hover:bg-moon">
            Meet the Buddies Meanwhile
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
